import { Observable } from "rxjs";
import { apiService } from "../../ApiService";
import { User } from "../../../model/User/User";

export type ContactMessageFormData = {
  email?: string;
  name?: string;
  message: string;
  object?: string;
  client?: string;
  clientVersion?: string;
};

export const sendContactMessage = (data: ContactMessageFormData): Observable<User> => {
  return apiService.request({
    method: "post",
    requiresAuthPolicy: "user",
    path: `v1/contact`,
    body: {
      ...data,
      name: data.name || data.email,
      object: data.object || `Support ${data.client} / ${data.clientVersion}`,
      to: "support@blacknut.com",
      message: `<p>${
        data.message
      }</p><p>--------------------------------------------------<br><small>Sent From ${JSON.stringify(
        apiService.userAgent,
      )}</small><br>-------------------------------------------------</p>`,
    },
  });
};
